// Wait for the DOM to be ready
$(function() {
  // Initialize form validation on the registration form.
  // It has the name attribute "registration"
  $("form[name='frmStore']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      fname: "required",
      email: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
      phone: "required",     
    },
    // Specify validation error messages
    messages: {
      fname: "Please enter your name",
      phone: "Please enter phone number",
      subject: "Please enter subject",
      message: "Please enter message",
      email: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {
      			var name = $('#fname').val(); 
				var email = $('#email').val(); 
      			var phone = $('#phone').val(); 
      			var subject = $('#subject').val(); 
      			var message = $('#message').val();
      			var storeName = $('#storeName').val();
			
      			var isGDPR = 0 ;
                if($('input[name="chkGDPRStore"]').is(':checked')) {
                  var isGDPR = 1;
                }
      
				// Create variables that will be sent in a URL string to mail.php
				var dataString = 'name=' + name + '&email='+ email + '&phone=' + phone + '&subject=' + subject + '&message=' + message+ '&store=' + storeName+ '&isGDPR=' + isGDPR;
      
      ga('send', 'event', 'stores', 'contacted');
      
      $.ajax({
            url: "/apps/chforest/store-query.php", 
            type: "POST",             
            data: dataString,
            cache: false,             
            processData: false,      
            success: function(data) {              
              	$('#storeMsgDiv').html('Thanks. You message has been sent. We will get back to you shorly');
              	$('#frmStore')[0].reset();
              
              	setTimeout(function(){
                  $('#storeMsgDiv').html('');
                }, 4000);
            }
        });
        return false;
    },    
  });
  
  
  $("form[name='frmEnquiry']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      contactFormName: "required",
      contactFormEmail: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
      contactFormMessage: "required",     
    },
    // Specify validation error messages
    messages: {
      contactFormName: "Please enter your name",
      contactFormMessage: "Please enter message",
      contactFormEmail: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {
      			var name = $('#contactFormName').val(); 
				var email = $('#contactFormEmail').val(); 
      			var message = $('#contactFormMessage').val();
      			var phone = $('#contactFormNumber').val();
      			var subject = $('#contactFormSubject').val();
      			
      			var isGDPR = 0 ;
                if($('input[name="chkGDPRContact"]').is(':checked')) {
                  var isGDPR = 1;
                }
      
				// Create variables that will be sent in a URL string to mail.php
				var dataString = 'name=' + name + '&email='+ email + '&message=' + message+ '&phone=' + phone+ '&subject=' + subject+ '&isGDPR=' + isGDPR;
      
       ga('send', 'event', 'Enquiry', 'Contact');
      
      $.ajax({
            url: "/apps/chforest/enquiry.php", 
            type: "POST",             
            data: dataString,
            cache: false,             
            processData: false,      
            success: function(data) {
                $('#enquiryMsgDiv').addClass('enquiryMsgDiv');
              	$('#enquiryMsgDiv').html('Thanks. You message has been sent. We will get back to you shorly');
              	   
                $('#contactFormName').val('');
                $('#contactFormEmail').val('');
                $('#contactFormMessage').val('');
                $('#contactFormNumber').val('');
                $('#contactFormSubject').val('');
                
              	setTimeout(function(){
                  $('#enquiryMsgDiv').html('');
                  $('#enquiryMsgDiv').removeClass('enquiryMsgDiv');
                }, 5000);
            }
        });
        return false;
    },    
  });
  
  
  $("form[name='frmSchoolEnquiry']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      contactFormName: "required",
      contactFormEmail: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
      contactFormNumber: "required",
      contactFormSchool: "required",
      contactFormAddress: "required",
      contactFormMessage: "required",
    },
    // Specify validation error messages
    messages: {
      contactFormName: "Please enter your name",
      contactFormMessage: "Please enter message",
      contactFormNumber: "Please enter contact number",
      contactFormSchool: "Please enter school name",
      contactFormAddress: "Please enter school address",
      contactFormEmail: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {      			
      			var name = $('#contactFormName').val(); 
				var email = $('#contactFormEmail').val(); 
      			var message = $('#contactFormMessage').val();
      			var phone = $('#contactFormNumber').val();
      			var school = $('#contactFormSchool').val();
      			var school_address = $('#contactFormAddress').val();
      			
      			var isGDPR = 0 ;
                if($('input[name="chkGDPRContact"]').is(':checked')) {
                  var isGDPR = 1;
                }
      
				// Create variables that will be sent in a URL string to mail.php
				var dataString = 'name=' + name + '&email='+ email + '&message=' + message+ '&phone=' + phone+ '&school=' + school+ '&school_address=' + encodeURIComponent(school_address)+ '&isGDPR=' + isGDPR;
      
       ga('send', 'event', 'SchoolTreeRequest', 'requested');
      
      $.ajax({
            url: "/apps/chforest/school_enquiry.php", 
            type: "POST",             
            data: dataString,
            cache: false,             
            processData: false,      
            success: function(data) {
                $('#enquiryMsgDiv').addClass('enquiryMsgDiv');
              	$('#enquiryMsgDiv').html('Thanks. You message has been sent. We will get back to you shorly');
              	   
                $('#contactFormName').val('');
                $('#contactFormEmail').val('');
                $('#contactFormMessage').val('');
                $('#contactFormNumber').val('');
                $('#contactFormSchool').val('');
                $('#contactFormAddress').val('');
                
              	setTimeout(function(){
                  $('#enquiryMsgDiv').html('');
                  $('#enquiryMsgDiv').removeClass('enquiryMsgDiv');
                }, 5000);
            }
        });
        return false;
    },    
  });
  
  
  $("form[name='frmStoreReserve']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      reservedForDateModal: "required",
      reservedFullName: "required",
      reservedPostalCode: "required",
      reservedEmail: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
      reservedPhone: "required",     
    },
    // Specify validation error messages
    messages: {
      reservedForDateModal: "Please enter date",
      reservedFullName: "Please enter your name",
      reservedPostalCode: "Please enter post code",
      reservedPhone: "Please enter phone number",
      reservedEmail: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {
      			var treeSize = $('#reserveTreeSize').val(); 
      			var date = $('#reservedForDateModal').val(); 
				var name = $('#reservedFullName').val(); 
      			var phone = $('#reservedPhone').val(); 
      			var email = $('#reservedEmail').val();
      			var postCode = $('#reservedPostalCode').val();
      			var store = $('#selectedStore').val();
      			var storeAddress = $('#storeAddress').val();
      			var storeName = $('#storeName').val();
			
      			var isGDPR = 0 ;
                if($('input[name="chkGDPRModal"]').is(':checked')) {
                  var isGDPR = 1;
                }
      
                // Create variables that will be sent in a URL string to mail.php
				var dataString = 'name=' + name + '&email='+ email + '&phone=' + phone + '&treeSize=' + treeSize + '&postCode=' + postCode + '&date=' + date+ '&storeHandle=' + 
                    store+'&storeAddress=' + storeAddress+ '&store=' + storeName+ '&isGDPR=' + isGDPR;
      
      $.ajax({
            url: "/apps/chforest/store-reserve-collect.php", 
            type: "POST",             
            data: dataString,
            cache: false,             
            processData: false,      
            success: function(data) { 
              
                ga('send', 'event', 'ReserveAndCollectForm', 'Requested');
              
              	$('#divModalForm').css('display','none');
              	$('#divReserveStatus').css('display','block');
              	$('#divReserveStatus').html(data); 
                
                displayReservedCollectInfo(store);
              
               $('#divReserveStatus').append("<p><a href='https://christmas-forest.myshopify.com/pages/real-christmas-tree-stores-london' style='color: #3f9900'>See details of our other stores</a></p>");
           }
        });
        return false;
    },    
  });
  
  $("form[name='frmHomeReserve']").validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      reservedForDate: "required",
      reservedFullName: "required",
      reservedPostalCode: "required",
      reservedEmail: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
      reservedPhone: "required",     
    },
    // Specify validation error messages
    messages: {
      reservedForDate: "Required",
      reservedFullName: "Required",
      reservedPostalCode: "Required",
      reservedPhone: "Required",
      reservedEmail: "Required"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {
      			var treeSize = $('#reserveTreeSize').val(); 
      			var date = $('#reservedForDate').val(); 
				var name = $('#reservedFullName').val(); 
      			var phone = $('#reservedPhone').val(); 
      			var email = $('#reservedEmail').val();
      			var postCode = $('#reservedPostalCode').val();
      			
      			if($('input[name="chkReservedGDPRR"]').is(':checked')) {
                  var isGDPR = 1;
                }
      
				// Create variables that will be sent in a URL string to mail.php
				var dataString = 'name=' + name + '&email='+ email + '&phone=' + phone + '&treeSize=' + treeSize + '&postCode=' + postCode + '&date=' + date+ '&isGDPR=' + isGDPR;
      
      $.ajax({
            url: "/apps/chforest/store-reserve-collect-nearby.php", 
            type: "POST",             
            data: dataString,
            cache: false,             
            processData: false,      
            success: function(data) {
              
                //ga('send', 'event', 'ReserveAndCollectForm', 'Requested');
              
                $('#successMsgDiv').css('display','block');
              	$('#successMsgDiv').html(data);
              
                
              
              	setTimeout(function(){
                  $('#successMsgDiv').html('');
                }, 5000);
           }
        });
        return false;
    },    
  });
  
});


